import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../common/constants";
import { uploadFirmwareUrl } from "../../config";
import api from "../../api";
import { IInitialSliceState } from "../../common/types/commonTypes";

const UPLOAD_FIRMWARES: string = "uploadFirmware";

interface IUploadFirmwareResponse {
  message: string;
  status: string;
}

const initialState: IInitialSliceState = {
  status: null,
  error: null,
  reqId: null,
  msg: null,
};
export const uploadFirmware = createAsyncThunk(
  UPLOAD_FIRMWARES,
  async (payload: { file: ArrayBuffer; name: string }, { rejectWithValue }) => {
    try {
      const headers: Record<string, string> = {
        "Content-Type": "application/octet-stream",
      };
      const response = await api.post<IUploadFirmwareResponse>(
        `${uploadFirmwareUrl}?filename=${payload.name}`,
        payload.file,
        { headers }
      );
      const uploadFirmwareResponse: IUploadFirmwareResponse = response.data;
      return uploadFirmwareResponse;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const uploadFirmwareSlice = createSlice({
  name: UPLOAD_FIRMWARES,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uploadFirmware.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = "";
      })
      .addCase(uploadFirmware.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.reqId = Math.random();
        state.status = Status.SUCCESS;
      })
      .addCase(uploadFirmware.rejected, (state, action) => {
        const errorPayload = action.payload as {
          response?: {
            data?: { error?: { message?: string }; message?: string };
          };
        };
        state.msg =
          errorPayload.response?.data?.error?.message ||
          errorPayload.response?.data?.message ||
          "Unknown error occurred";
        state.reqId = Math.random();
        state.status = Status.FAILED;
      });
  },
});

type Selector = {
  uploadFirmwareApi: ReturnType<typeof uploadFirmwareSlice.reducer>;
};

export const selector = (store: Selector) => store["uploadFirmwareApi"];

export default uploadFirmwareSlice.reducer;
